angular.module('Itao.IndicatorMap').directive('indicatorDataLayerTimeLine', function (mapConfig, $interval) {
  'use strict';

  return {
    templateUrl: mapConfig.templateBasePath + 'dataLayerTimeLine.html',
    restrict: 'E',
    scope: {
      selectedDataLayer: '=',
      selectedDataLayerType: '=',
      layers: '=',
      availableIndicators: '=',
      onDataLayerSelect: '&',
      selectedIndicator: '=',
      yearsOverwrite: '='
    },
    link: function (scope, element) {
      scope.layers = [];
      scope.years = Object.keys(scope.layers);
      scope.yearsToHide = mapConfig.yearsToHide;

      var layerInterval = null;

      scope.intervalIsRunning = false;
      scope.playLayers = function () {
        if (!scope.years.length) {
          saveYearsInsideArray();
        }
        layerInterval = $interval(showNextYear, 1000);

        jQuery(element).find('.progress').addClass('running');
        scope.intervalIsRunning = true;
      };

      function showNextYear() {
        var currentYearIndex = scope.years.indexOf(scope.selectedDataLayer.year),
          nextIndex = currentYearIndex + 1;

        if (currentYearIndex === scope.years.length - 1) {
          nextIndex = 0;
        }

        var nextLayer = scope.layers[scope.years[nextIndex]];
        scope.onDataLayerSelect({dataLayer: nextLayer});
        scope.layersSlider.value = scope.years[nextIndex];
      }

      scope.stopLayers = function () {
        jQuery(element).find('.progress').removeClass('running');
        $interval.cancel(layerInterval);
        scope.intervalIsRunning = false;
      };

      function saveYearsInsideArray() {
        scope.years = Object.keys(scope.layers);
        if (scope.selectedIndicator) {
          filterYearsByIndicator();
        }
      }

      scope.$watch('selectedIndicator', function (selectedIndicator) {
        if (selectedIndicator && scope.layers) {
          saveYearsInsideArray();
        }
      });

      function filterYearsByIndicator() {
        if (!scope.availableIndicators) return;
        var availableIndicatorUids = Object.keys(scope.availableIndicators).map(function (id) {
          return +id;
        });

        angular.forEach(scope.layers, function (layer, year) {
          var intersections = layer.indicators.filter(function (e) {
            return availableIndicatorUids.indexOf(e) !== -1;
          });

          if (intersections.length === 0) {
            scope.years.splice(scope.years.indexOf(year), 1);
          }
        });
        rebuildSlider();
      }

      scope.$watchCollection('layers', function () {
        saveYearsInsideArray();
        rebuildSlider();
      });

      function rebuildSlider() {
        var stepsArray = [];

        //var years = mapConfig.yearsToHide ? scope.years.filter(function (year) {
        //  return mapConfig.yearsToHide.indexOf(year) === -1;
        //}) : scope.years;

        var years = scope.years;
        angular.forEach(years, function (year, index) {
          var legendString = '';
          if (years.length > 5 && index > 0 && index < years.length - 1) {
            legendString = "'" + year.substring(2);
          } else {
            legendString = year;
          }
          stepsArray.push({value: +year, legend: legendString});
        });

        scope.layersSlider.options.stepsArray = stepsArray;
        scope.layersSlider.value = scope.selectedDataLayer ? scope.selectedDataLayer.year : years.indexOf[0];
      }

      scope.layersSlider = {
        value: 0,
        options: {
          onChange: function () {
            scope.onDataLayerSelect({dataLayer: scope.layers[scope.layersSlider.value]});
          },
          showSelectionBar: true,
          hidePointerLabels: true,
          showTicksValues: true
        }
      };
    }
  };
});
